(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebcb3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebcb3"] = parcelRequire;
}
parcelRequire.register("7mds7", function(module, exports) {
/*
 * -----------------------------------------------------------------------------
 * @cam/quick-view-popup
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Quickview popup content fetched via Shopify Section Rendering API.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @param data-url {String} URL to fetch.
 * @param [data-section-id] {String} Section to fetch.
 * -----------------------------------------------------------------------------
 * @requires @cam/popup
 * -----------------------------------------------------------------------------
*/ if (customElements.get("quick-view-popup") === undefined) {
    class QuickViewPopup extends HTMLElement {
        constructor(){
            super();
            this.button = this.querySelector("button");
            this.popupToggle = this.querySelector("popup-toggle");
            this.popupContent = this.querySelector("[data-popup-content]");
            this.button?.addEventListener("click", this.clickEvent.bind(this), false);
        }
        clickEvent() {
            this.loadingState(true);
            fetch(`${this.dataset.url}?section_id=${this.dataset.sectionId}`).then((response)=>response.text()).then((responseText)=>{
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.popupContent = this.querySelector("[data-popup-content]");
                this.popupContent.innerHTML = html.body.innerHTML;
                this.popupContent.querySelectorAll("script").forEach((script)=>{
                    if (script.src) fetch(script.src).then((data)=>data.text().then((content)=>eval(content)));
                    script.parentNode.removeChild(script);
                });
                this.popupToggle.open();
                this.loadingState(false);
            }).catch((error)=>this.errorHandler(error));
        }
        loadingState(state) {
            state ? [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.add("loading")) : [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.remove("loading"));
        }
        errorHandler(error) {
            this.loadingState(false);
            console.error("An error has occured", error);
        }
    }
    customElements.define("quick-view-popup", QuickViewPopup);
}

});

parcelRequire("7mds7");

})();
